import { render, staticRenderFns } from "./Bien.vue?vue&type=template&id=1e28d53a&"
import script from "./Bien.vue?vue&type=script&lang=js&"
export * from "./Bien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports